__turbopack_context__.v({
  "floatBtn": "FloatingContactButtons-module__2_nAXq__floatBtn",
  "phoneBtn": "FloatingContactButtons-module__2_nAXq__phoneBtn",
  "phonePulse": "FloatingContactButtons-module__2_nAXq__phonePulse",
  "tooltip": "FloatingContactButtons-module__2_nAXq__tooltip",
  "whatsappBtn": "FloatingContactButtons-module__2_nAXq__whatsappBtn",
  "whatsappPulse": "FloatingContactButtons-module__2_nAXq__whatsappPulse",
});
